import { Component } from '@angular/core';
import { IzzyPendingCrawlResultEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Pending Crawl Results') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzypendingcrawlresult-form',
    templateUrl: './izzypendingcrawlresult.form.component.html'
})
export class IzzyPendingCrawlResultFormComponent extends BaseFormComponent {
    public record!: IzzyPendingCrawlResultEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'crawlContext', sectionName: 'Crawl Context', isExpanded: true },
            { sectionKey: 'reviewWorkflow', sectionName: 'Review Workflow', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

